module.exports = __webpack_public_path__ + "static/media/card-3.0c891f8b.svg";